import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { planesStartDelete, planLogout, startLoadingPlanes } from '../../actions/planes';
import { setMenuLateral } from '../../actions/ui';
import { formatCurrency } from '../../helpers/helpers';

export const Planes = ({ history }) => {

    const dispatch = useDispatch();
    const { planes } = useSelector(state => state.planes);
    const { colores } = useSelector(state => state.ui);
    const { actualSuscripcion } = useSelector(state => state.auth);

    const [searchActive, setSearchActive] = useState(false);
    const [searchTxt, setSearchTxt] = useState('');
    const [planesList, setPlanesList] = useState([]);
    
    const planActual = {
        _id: 'plan-pro',
        nombre: 'Pro',
        mensual: 34.90,
        profesionales: 3,
        formacion: 2,
        recomendado: true
    };

    const [modalEliminarPlanOpened, setModalEliminarPlanOpened] = useState(false);
    const [dataModalEliminar, setDataModalEliminar] = useState({
        title: '¿Eliminar plan?',
        text: [],
        buttonText: 'Eliminar',
        button2Text: 'Cancelar'
    });

    const [selectedId, setSelectedId] = useState('');

    useEffect(() => {
        dispatch(setMenuLateral('planes'));
        dispatch(startLoadingPlanes());

        return () => {
            dispatch(planLogout());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        //console.log( 'planes', planes );
        procesaPlanes(planes, false);
    }, [planes]);

    /* useEffect(() => {
        console.log('planesList', planesList);
    }, [planesList]) */

    useEffect(() => {
        /* if( searchTxt.trim().length > 3 ){
            dispatch( startSearchEmpresas( searchTxt.trim(), pagNumber | 1, LIMITE_EMPRESAS, orderBy, asc ) );
            setInitialSearch( false );
        } */
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchTxt]);

    const procesaPlanes = (planes, filtro = true) => {
        let newPlanes = [];
        //console.log( 'procesaPlanes', planes );
        //console.log( 'totalPlanes', totalPlanes );
        let contador = 0;
        planes.forEach(plan => {
            if (!plan.deleted) {
                newPlanes = [...newPlanes, plan];
                contador++;
            }
            if (filtro) {
                if (contador > 14) {
                    return;
                }
            }
        });
        setPlanesList(newPlanes);
    }

    const clickSearch = () => {
        if (searchActive) {
            setSearchTxt('');
        }
        setSearchActive(!searchActive);
    };

    const clickDeleteSearch = () => {
        setSearchTxt('');
    }

    const handleSearchChange = (e) => {
        setSearchTxt(e.target.value);
    }

    const clickAdd = () => {
        history.push({
            pathname: `/plan/new`
        });
    };

    const editPlan = (plan) => {
        history.push({
            pathname: `/plan/${plan._id}`,
            state: {
                plan
            }
        });
    };

    const deletePlanModal = (planId, name) => {
        setSelectedId(planId);
        setDataModalEliminar({
            ...dataModalEliminar,
            text: [`¿Estás seguro de que deseas eliminar el plan ${name}?`]
        })
        setModalEliminarPlanOpened(true);
    };

    const deletePlanResponse = (value) => {
        if (value === 1 && selectedId !== '') {
            // console.log( 'Borrar id:', selectedId );
            dispatch(planesStartDelete(selectedId));
        }
    }

    return (
        <>
            <div
                className='empresas'
                style={{
                    '--colorPrincipal': colores.colorPrincipal,
                    '--colorSecundario': colores.colorSecundario,
                    '--color3': colores.color3,
                    '--color4': colores.color4,
                    '--color5': colores.color5,
                    '--color6': colores.color6,
                    '--color7': colores.color7,
                }}
            >
                <div className="preheader">
                    <div className="title">
                        <h1 style={{ color: colores.colorPrincipal }}>Planes</h1>
                    </div>
                    <div className="botonera"></div>
                </div>
                <div className='planes-list'>
                    <div
                        key={planActual._id}
                        className='plan-item'
                    >
                        <div className='plan-header'>
                            <div className='recomendado'>Recomendado</div>
                            <h5>Plan Pro</h5>
                            <div className='price'>
                                <p>34,90€<span>/ mes</span></p>
                            </div>
                        </div>
                        <div className='plan-body'>
                            <div className='plan-feature'>
                                <div className='plan-check'><div className='plan-check-item'></div></div>
                                <p>1 profesional incluido</p>
                            </div>
                            <div className='plan-feature'>
                                <div className='plan-check'><div className='plan-check-item'></div></div>
                                <p>+ 8€ por cada profesional</p>
                            </div>
                            <div className='plan-feature'>
                                <div className='plan-check'><div className='plan-check-item'></div></div>
                                <p>Reservas y servicios ilimitados</p>
                            </div>
                            <div className='plan-feature'>
                                <div className='plan-check'><div className='plan-check-item'></div></div>
                                <p>Gestión de clientes y agenda</p>
                            </div>
                            <div className='plan-feature'>
                                <div className='plan-check'><div className='plan-check-item'></div></div>
                                <p>Clientes ilimitados</p>
                            </div>
                            <div className='plan-feature'>
                                <div className='plan-check'><div className='plan-check-item'></div></div>
                                <p>Historial de citas</p>
                            </div>
                        </div>
                        <div className='plan-footer'>
                            <p>{planActual.formacion}h. de formación</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
